<template>
  <div class="row page-heading">

	<div class="module_heading mod_name">
		<div class="module_type_name" v-if="!isYearView"> {{currentSemester}} {{currentYear}}</div>
		<div class="module_type_name" v-if="isYearView"> Academic Year {{computedAcademicYear}}</div>
	</div>

	<div class="tab_section">
		<div class="tab-row calendar_tabs">
			<div v-if="plannerViewFeatureMap.enabled" class="tab-col" :style="{'background': (isYearView ? '#f5f5f5' : '')}" @click='goToYearView'>{{yearViewLabel}}</div>
			<div class="tab-col" :style="{'background': (isCalendarView ? '#f5f5f5' : '')}" @click='goToCalendarView'>calendar view</div>
			<div class="tab-col" :style="{'background': (isDetailView ? '#f5f5f5' : '')}" @click='goToDetailView'>detail view</div>
		</div>
	</div>

	<div class="btn_container" v-if="!isYearView">

		<b-dropdown right :animation="animation" variant="link" no-caret class="create-section-menu">
			<template slot="button-content">
				<span class="icon-menu3x3" aria-label="dropdown menu"></span>
			</template>
			<b-dropdown-item v-if="scheduleCheckFlagMap.showShare.enabled" aria-label="Share" v-b-modal.shareStream>Share</b-dropdown-item>
			<b-dropdown-item v-if="scheduleCheckFlagMap.showPrint.enabled" aria-label="Print" @click='printButtonClicked'>Print</b-dropdown-item>
			<b-dropdown-item v-if="scheduleCheckFlagMap.showGoogleCalSync.enabled" @click='syncWithGoogleCalendarClicked'  aria-label="Sync with Google Calendar">Sync with Google Calendar</b-dropdown-item>
			<b-dropdown-item v-if="scheduleCheckFlagMap.showCalExport.enabled" aria-label="Export as iCal" @click='exportAsICal'>Export as iCal</b-dropdown-item>
		</b-dropdown>

		<b-button-group>
		  <!-- <b-button @click='shareButtonClicked'>share</b-button> -->
		  <sharing :entity-type="'entity'" :entity-uuid="streamUuid"></sharing>
      <b-btn v-if="showPlanStreamButton" @click="planStreamClicked">{{planStreamLabel}}</b-btn>
		  <b-button v-if="!showPlanStreamButton" @click="goToPlanningClicked" aria-label="go to planning">go to planning</b-button>
		</b-button-group>

		<div class="legend-section">
			<div class="legend-column" title="Scheduled Class">
				<div class="legend-block shedule"></div>
				<div class="legend-text">Scheduled</div>
			</div>
			<div class="legend-column" style="margin-right: 0px;" title="Conflicting Class">
				<div class="legend-block conflict"></div>
				<div class="legend-text">Conflicting</div>
			</div>
		</div>
	</div>

	  <div class="btn_container" v-else>
	    <b-button-group>
			  <!-- <b-button @click='shareButtonClicked'>share</b-button> -->
			  <sharing :entity-type="'entity'" :entity-uuid="streamUuid"></sharing>
			  <b-button @click="goToPlanningClicked" aria-label="go to planning">go to planning</b-button>
			</b-button-group>
	    <div class="legend-section">
				<div class="legend-column" title="Scheduled Class">
					<div class="legend-block shedule" style="background: #8eb056;"></div>
					<div class="legend-text">Scheduled</div>
				</div>
				<div class="legend-column" style="margin-right: 0px;" title="Conflicting Class">
					<div class="legend-block conflict"></div>
					<div class="legend-text">Conflicting</div>
				</div>
			</div>
	  </div>




  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import Sharing from '../../sharing/components/Sharing'
  import { PACKAGE } from '../../../package_constants'
  import { PackageUtil } from '../../../package_utils'

  export default {
    name: 'semester-header',
    props: ['streamUuid', 'currentSemester', 'currentYear', 'parentComponent', 'isPlanningStream'],
    components: {
      Sharing
    },
    data: () => {
      return {
      }
    },
    mounted () {
      this.loadData()
    },
    methods: {
      ...mapActions([
        'populateCourses',
        'loginToGoogleCalendar',
        'getICalFile',
        'loadLogDashboardActivity'
      ]),
      loadData () {
        // TODO remove if not needed
      },
      notifySuccess (text) {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: text
        })
      },
      notifyFailure (text) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      },
      onShown () {
        console.log('onShown called')
      },
      executeGoogleCalendarSync () {
        this.loadLogDashboardActivity({action: 'clickGoogleCalendarSync', page: 'Schedule Check', link: 'Google Calendar Sync'})
        let streamUuid = this.streamUuid
        let currentSemester = this.currentSemester
        let currentYear = this.currentYear
        localStorage.setItem('streamUuid', streamUuid)
        localStorage.setItem('currentSemester', currentSemester)
        localStorage.setItem('currentYear', currentYear)

        this.loginToGoogleCalendar().then((response) => {
          let childWindow = window.open(response, null, 'height=700,width=1200,status=yes,toolbar=no,menubar=no,location=no,resizable=no,scrollbars=no,directories=no,left=200,top=50')
          childWindow.focus()
        })
      },
      syncWithGoogleCalendarClicked () {
        console.log('syncWithGoogleCalendarClicked')
        this.executeGoogleCalendarSync()
      },
      writeFile (data) {
        const blob = new Blob([data], {type: 'text/plain'})
        const e = document.createEvent('MouseEvents')
        let a = document.createElement('a')
        a.download = 'my_download.ics'
        a.href = window.URL.createObjectURL(blob)
        a.dataset.downloadurl = ['text/json', a.download, a.href].join(':')
        e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
        a.dispatchEvent(e)
      },
      exportAsICal () {
        this.loadLogDashboardActivity({action: 'clickExportAsIcal', page: 'Schedule Check', link: 'Export as ICAL'})
        let streamUuid = this.streamUuid
        let currentSemester = this.currentSemester
        let currentYear = this.currentYear

        this.getICalFile({streamUuid: streamUuid, currentYear: currentYear, currentSemester: currentSemester}).then(response => {
          let iCalFile = response['fileContents']
          console.log('writing to file: ', iCalFile)
          this.writeFile(iCalFile)
        })
      },
      shareButtonClicked () {
        console.log('shareButtonClicked clicked!')
      },
      goToPlanning () {
        console.log('goToPlanning clicked!')
      },
      goToCalendarView () {
        console.log('calendar view clicked')
        this.loadLogDashboardActivity({action: 'clickCalendarView', page: 'Schedule Check', link: 'calendar view'})
        let streamUuid = this.streamUuid
        let currentSemester = this.currentSemester
        let currentYear = this.currentYear
        return this.$router.push({ name: 'semesterCalendarView', params: {streamUuid: streamUuid, currentYear: currentYear, currentSemester: currentSemester} })
      },
      goToDetailView () {
        console.log('detail view clicked')
        this.loadLogDashboardActivity({action: 'clickDetailView', page: 'Schedule Check', link: 'detail view'})
        let streamUuid = this.streamUuid
        let currentSemester = this.currentSemester
        let currentYear = this.currentYear
        return this.$router.push({ name: 'semesterDetailView', params: {streamUuid: streamUuid, currentYear: currentYear, currentSemester: currentSemester} })
      },
      goToYearView () {
        console.log('year view clicked')
        // this.loadLogDashboardActivity({action: 'clickDetailView', page: 'Schedule Check', link: 'detail view'})
        let streamUuid = this.streamUuid
        let currentSemester = this.currentSemester
        let currentYear = this.currentYear
        return this.$router.push({ name: 'semesterPlannerView', params: {streamUuid: streamUuid, academicYear: this.academicYear, currentYear: currentYear, currentSemester: currentSemester} })
      },
      printButtonClicked () {
        this.loadLogDashboardActivity({action: 'printSchedule', page: 'Schedule Check', link: 'print'})
        window.print()
      },
      goToPlanningClicked () {
        return this.$router.push({ name: 'courseSearchResults', params: {isPlanning: true} })
      },
      getCoursePlanningPackage () {
        let packages = this.packages
        if (!packages || !packages.length || packages.length <= 0) {
          return {}
        }
        return PackageUtil.getCoursePlanningPackage(packages)
      },
      planStreamClicked () {
        return this.$router.push({ name: 'planStream', params: { uuid: this.stream.uuid } })
      }
    },
    computed: {
      ...mapState({
        'courses': state => state.semester.courses,
        'iCalFile': state => state.semester.iCalFile,
        'permission': state => state.user.permission,
        'packages': state => state.institution.packages,
        'enabledFeatures': state => state.institution.enabledFeatures,
        'academicYear': state => state.advancedSearch.academicYear,
        'stream': state => state.stream.stream
      }),
      iCalEvents () {
        let iCalFile = this.iCalFile
        return iCalFile['fileContents']
      },
      isCalendarView () {
        let parent = this.parentComponent
        return parent === 'Calendar'
      },
      isDetailView () {
        let parent = this.parentComponent
        return parent === 'Detail'
      },
      isYearView () {
        let parent = this.parentComponent
        return parent === 'Year'
      },
      computedAcademicYear () {
        if (!this.academicYear) {
          return this.academicYearDefault
        }
        return this.academicYear
      },
      scheduleCheckFlagMap () {
        let featureId = PACKAGE.FEATURE_IDS.SCHEDULE_CHECK_FEATURE_ID
        let coursePlanningPackage = this.getCoursePlanningPackage()
        return PackageUtil.getFlagsFromPackageFeature(coursePlanningPackage, featureId)
      },
      plannerViewFeatureMap () {
        let featureId = PACKAGE.FEATURE_IDS.PLANNER_VIEW_FEATURE_ID
        let coursePlanningPackage = this.getCoursePlanningPackage()
        return PackageUtil.getFeatureFromPackage(coursePlanningPackage, featureId)
      },
      yearViewLabel () {
        let label = 'year view'
        let plannerViewFeatureMap = this.plannerViewFeatureMap
        if (plannerViewFeatureMap.enabled && plannerViewFeatureMap.label) {
          label = plannerViewFeatureMap.label
        }
        return label
      },
      showPlanStreamButton () {
        let isPlanningStream = this.isPlanningStream === true
        return isPlanningStream && this.isPlanStreamEnabled && this.canEditPlanningStream
      },
      isPlanStreamEnabled () {
        let planStreamFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PLAN_STREAM_FEATURE_ID]
        if (planStreamFeature && planStreamFeature.enabled) {
          return true
        }
        return false
      },
      planStreamLabel () {
        let planStreamFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PLAN_STREAM_FEATURE_ID]
        if (!planStreamFeature || !planStreamFeature.label) {
          return 'plan stream'
        }
        return planStreamFeature.label
      },
      ownerId () {
        let stream = this.stream
        return stream && stream.ownerId ? stream.ownerId : ''
      },
      accessControlList () {
        let stream = this.stream
        if (!stream || !stream.acelist) {
          return []
        }
        return stream.acelist
      },
      usersPermittedToEdit () {
        let users = this.ownerId && this.ownerId.length ? [this.ownerId] : []
        let accessControlList = this.accessControlList
        if (!accessControlList) {
          return users
        }
        const WRITE_PERMISSION = this.WRITE_PERMISSION
        const SHARE_PERMISSION = this.SHARE_PERMISSION
        accessControlList.forEach(accessControl => {
          let permission = accessControl.permission || {}
          let principal = accessControl.principal || {}
          let userIdList = principal.userUuidList
          let isEditPermission = permission.name === WRITE_PERMISSION || permission.name === SHARE_PERMISSION
          if (isEditPermission && userIdList) {
            userIdList.forEach(userId => {
              users.push(userId)
            })
          }
        })
        return users
      },
      canEditPlanningStream () {
        let showButton = false
        let usersPermittedToEdit = this.usersPermittedToEdit
        if (this.userrole === this.instructorAdminRole) {
          return true
        }
        if (!usersPermittedToEdit || !usersPermittedToEdit.length) {
          return false
        }
        usersPermittedToEdit.forEach(userId => {
          if (userId === this.userId) {
            showButton = true
          }
        })
        return showButton
      }
    }
  }
</script>

<style scoped>
.conflict {
    color: red
}

.no-conflict {
    color: green
}
</style>



// WEBPACK FOOTER //
// src/app/semester/components/SemesterHeader.vue